import React from 'react'
import Header from '../../components/Header'
import Hero from './Hero'
import WhyChooseUs from './WhyChooseUs'
import ContentSection from './ContentSection'
import Timeline from './TImeline'
import DeliverySolutions from './DeliverySolutions'
import Status from '../Home/Status'
import IndustriesWeServe from './IndustriesWeServe'
import Form from '../Home/Form'
import Footer from '../../components/Footer'

const Businesses = () => {

    return (
        <div>
            <Header />

            <Hero />

            <ContentSection />

            <WhyChooseUs />

            <Timeline />

            <DeliverySolutions />

            <Status />

            <IndustriesWeServe />

            <Form />

            <Footer />
        </div>
    )
}

export default Businesses
